import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'material-ui/Checkbox';
import DatePicker from "material-ui/DatePicker";
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';

import StatusIcon from 'material-ui/svg-icons/action/done';
import CancelledIcon from 'material-ui/svg-icons/content/clear';
import WaitingIcon from 'material-ui/svg-icons/action/schedule';

import { statusColours } from '../../constants/ColourConstants';
import { DateStyles } from "../../constants/CentricConstants";

const sanitiseParams = (params) => {
    let changes = {};
    if (params.dateStart) {
        changes = {dateStart: params.dateStart.toLocaleString('en-GB', DateStyles.long)};
    }
    if (params.dateCompleted) {
        changes = {...changes, dateCompleted: params.dateCompleted.toLocaleString('en-GB', DateStyles.long)};
    }
    return !changes ? params : {...params, ...changes};
};


class CourseEnrolmentEditDialog extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            status:         this.props.data && this.props.data.status,
            score:          this.props.data && this.props.data.score,
            scoreError:     null,
            isMandatory:    null,
            canRetake:      (this.props.data && this.props.data.canRetake) || null,
            dateStart:      (!!this.props.data && !!this.props.data.dateStart) ? new Date(this.props.data.dateStart) : null,
            dateCompleted:  (!!this.props.data && !!this.props.data.dateCompleted) ? new Date(this.props.data.dateCompleted) : null
        };
    }

    componentDidMount() {
        this.onStatusChange = this.onStatusChange.bind(this);
        this.onScoreChange = this.onScoreChange.bind(this);
        this.onMandatoryChange = this.onMandatoryChange.bind(this);
        this.onRetakeChange = this.onRetakeChange.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let changes = {}, changed = false;
        if (nextProps.data.status !== this.props.status) {
            changes.status = nextProps.data.status;
            changed = true;
        }
        if (nextProps.data.score !== this.props.score) {
            changes.score = nextProps.data.score;
            changed = true;
        }
        if (nextProps.data.isMandatory !== this.props.isMandatory) {
            changes.isMandatory = nextProps.data.isMandatory;
            changed = true;
        }
        if (nextProps.data.canRetake !== this.props.canRetake) {
            changes.canRetake = nextProps.data.canRetake;
            changed = true;
        }
        if (nextProps.data.dateStart !== this.props.dateStart) {
            changes.dateStart = new Date(nextProps.data.dateStart);
            changed = true;
        }
        if (nextProps.data.dateCompleted !== this.props.dateCompleted) {
            changes.dateCompleted = new Date(nextProps.data.dateCompleted);
            changed = true;
        }

        if (changed) {
            this.setState(changes);
        }
    }

    render() {
        const dialogProps = {
            title: this.props.title,
            open:  this.props.open,
            onRequestClose: this.props.onClose,
            actions: [
                <FlatButton label="Cancel" key="cancel" onTouchTap={this.props.onCancel} />,
                <FlatButton label="save"  key="apply" onTouchTap={this.onSave} primary={true} />
            ]
        };

        let statusList;
        if (!!this.props.statusList && this.props.statusList.length > 0) {
            statusList = this.props.statusList.map( ({id, name}) => {

                let icon = '';

                switch(id) {

                    case 'cancelled':
                         icon = <CancelledIcon color={statusColours[id]}/>;
                        break;

                    case 'waiting':
                        icon = <WaitingIcon />;
                        break;

                    case 'enrolled':
                        icon = <StatusIcon />;
                        break;

                    case 'completed':
                        icon = <StatusIcon color={statusColours[id]}/>;
                        break;

                    default:
                        break;

                }

                return (<MenuItem key={id} value={id} primaryText={name} leftIcon={icon}/>);
            });
        }

        return (
            <Dialog {...dialogProps} >
                <div className='cent-flex-row'>
                    <div className='cent-col-2'>
                        <SelectField
                            hintText="Status"
                            floatingLabelText="Status"
                            value={this.state.status}
                            fullWidth={true}
                            onChange={this.onStatusChange}
                        >
                            {statusList}
                        </SelectField>
                    </div>
                    <div className='cent-col-2'>
                        <TextField
                            name="score"
                            defaultValue={this.state.score}
                            errorText={this.state.scoreError}
                            hintText="Score"
                            floatingLabelText="Score"
                            onChange={this.onScoreChange}
                            fullWidth
                        />
                    </div>
                    <div className='cent-col-2'>
                        <DatePicker
                            name="dateStart"
                            maxDate={this.state.dateCompleted || new Date()}
                            hintText="Date enrolled"
                            floatingLabelText="Date enrolled"
                            value={this.state.dateStart}
                            onChange={(e, value) => this.setState({dateStart: value})}
                            disabled={!['enrolled', 'completed'].includes(this.state.status)}
                            fullWidth
                        />
                    </div>
                    <div className='cent-col-2'>
                        <DatePicker
                            name="dateCompleted"
                            minDate={this.state.dateStart}
                            maxDate={new Date()}
                            hintText="Date completed"
                            floatingLabelText="Date completed"
                            value={this.state.dateCompleted}
                            onChange={(e, value) => this.setState({dateCompleted: value})}
                            disabled={this.state.status !== 'completed'}
                            fullWidth
                        />
                    </div>
                    <div className='cent-col-2'>
                        <div className='cent-checkbox-wrapper'>
                            <div className='cent-checkbox-hint'>User can retake course after completion</div>
                            <Checkbox label="Allow Retake" defaultChecked={this.props.data && this.props.data.canRetake} onCheck={this.onRetakeChange}/>
                        </div>
                    </div>
                    <div className='cent-col-2'>
                        <div className='cent-checkbox-wrapper'>
                            <div className='cent-checkbox-hint'>Completion requirement</div>
                            <Checkbox label="Mandatory" defaultChecked={this.props.data && this.props.data.isMandatory} onCheck={this.onMandatoryChange}/>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }

    onStatusChange(e, key, value) {
        this.setState({
            ...this.state,
            status: value,
            dateStart: ['waiting', 'cancelled'].includes(value) ? null : this.state.dateStart || new Date(),
            dateCompleted: value === 'completed' ? new Date() : null
        });
    }

    onScoreChange({target}) {
        this.setState({score: target.value, scoreError: (target.value === '' ? 'Required' : (isNaN(Number(target.value)) && 'Please use only numbers'))});
    }

    onMandatoryChange(e, value) {
        this.setState({isMandatory: value});
    }

    onRetakeChange(e, value) {
        this.setState({canRetake: value});
    }

    onSave() {
        this.props.onSave(sanitiseParams(this.state));
        if (this.props.closeOnSave) {
            this.props.onClose();
        }
    }
}

CourseEnrolmentEditDialog.propTypes = {
    open:       PropTypes.bool,
    title:      PropTypes.string,
    data:       PropTypes.shape({
        status:         PropTypes.string,
        score:          PropTypes.number,
        isMandatory:    PropTypes.bool,
        canRetake:      PropTypes.bool,
        dateStart:      PropTypes.object,
        dateCompleted:  PropTypes.object
    }),
    statusList: PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.string.isRequired,
            name:   PropTypes.string.isRequired
        })
    ),
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool
};

CourseEnrolmentEditDialog.defaultProps = {
    open:           false,
    title:          'Edit enrolment',
    onClose:        () => true,
    onCancel:       () => true,
    onSave:         () => true,
    closeOnSave:    true
};

export default CourseEnrolmentEditDialog;
